import axios from 'axios';
import ApiError from './error';

const LocationService = {
  getAll() {
    return axios.get('location').catch((e) => {
      throw new ApiError(e);
    });
  },
  get(id) {
    return axios.get(`location/${id}`).catch((e) => {
      throw new ApiError(e);
    });
  },
};

export default LocationService;
